import { defineRecipe } from '@chakra-ui/react';
import fonts from '../fonts';
import colors from '../colors';

const Text = defineRecipe({
  base: {
    fontFamily: fonts.normal,
    color: 'podcastShade600',
    lineHeight: '24px',
    fontSize: '16px',
    textShadow: 'none',
  },
  variants: {
    size: {
      none: {},
      p1: {
        fontSize: { sm: '16px', md: '18px' },
        lineHeight: { sm: '24px', md: '30px' },
      },
      p2: {
        fontSize: { sm: '12px', md: '16px' },
        lineHeight: { sm: '18px', md: '24px' },
      },
      p3: {
        fontSize: { sm: '11px', md: '13px' },
        lineHeight: { sm: '18px', md: '18px' },
      },
      p4: {
        fontSize: { sm: '9px', md: '11px' },
        lineHeight: { sm: '12px', md: '18px' },
      },
    },
    visual: {
      primary: {},
      lighter: { color: 'podcastShade500' },
      dark: { color: 'podcastShade600' },
      darker: { color: 'podcastShade700' },
      bold: { fontFamily: fonts.bold },
      libraryHeading: {
        color: colors.podcastPurple,
        fontSize: '15px !important',
        letterSpacing: '0.4px',
      },
      popover: {
        fontFamily: fonts.normal,
        fontSize: '13px',
        lineHight: '18px',
        color: 'podcastShade400',
      },
      emptyFile: {
        fontSize: '13px',
        textAlign: 'center',
        alignSelf: 'center',
        fontFamily: fonts.bold,
        color: 'podcastShade400',
      },
      ghost: {
        color: 'podcastShade400',
      },
    },
  },

  defaultVariants: {
    visual: 'primary',
    size: 'none',
  },
});

export default Text;
